import { render, staticRenderFns } from "./CommentKeyboard.vue?vue&type=template&id=1293bc58&scoped=true&"
import script from "./CommentKeyboard.vue?vue&type=script&lang=js&"
export * from "./CommentKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./CommentKeyboard.vue?vue&type=style&index=0&id=1293bc58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293bc58",
  null
  
)

export default component.exports